import { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";

// A reference the payer has to quote is copied, not retyped: a misread
// digit sends support looking for a payment that does not exist.
const CopyButton = ({ value, label }: { value: string; label: string }) => {
  const { t } = useTranslation();
  const [result, setResult] = useState<"copied" | "failed" | null>(null);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setResult("copied");
    } catch {
      // No clipboard (insecure context or refused): the payer is told, and
      // the value stays selectable on screen to copy by hand.
      setResult("failed");
    }
  };

  return (
    <Box display="inline-flex" alignItems="center" gap={0.5}>
      <IconButton size="small" aria-label={label} onClick={copy}>
        <ContentCopyIcon fontSize="small" />
      </IconButton>
      <Typography component="span" role="status" fontSize={12}>
        {result === "copied"
          ? t("copy.copied")
          : result === "failed"
          ? t("copy.failed")
          : ""}
      </Typography>
    </Box>
  );
};

export default CopyButton;
